import { ChildComponentMixin } from '@/mixins'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class CommonForm extends ChildComponentMixin {
    @Prop() public errors?: any

    public errorFor(field: string): string {
        if (this.errors == null) {
            return ''
        }

        const error = Object.entries(this.errors).find(
            (el) => el[0] === field,
        )

        const errorMessage = error != null ? error[1] : ''
        return (errorMessage || '') as string
    }
}
